/* Cookie consent banner: once the visitor accepts or refuses, the choice is
   stored in localStorage and the banner is never shown again. */
(function () {
  const STORAGE_KEY = 'hdt_cookie_consent';

  function resetCookieStorage() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      /* storage unavailable, fail silently */
    }
  }

  window.HdtCookieBanner = {
    reset() {
      resetCookieStorage();
      window.location.reload();
    },
  };

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState === 'complete' || document.readyState === 'interactive') init();

  function init() {
    document.querySelectorAll('[data-hdt-cookie-reset]').forEach((button) => {
      if (button.dataset.hdtResetBound) return;
      button.dataset.hdtResetBound = 'true';
      button.addEventListener('click', () => window.HdtCookieBanner.reset());
    });

    const banner = document.querySelector('[data-hdt-cookie-banner]');
    if (!banner) return;

    const existingConsent = readStorage(STORAGE_KEY);
    if (existingConsent === 'accepted' || existingConsent === 'refused') return;

    banner.hidden = false;

    const acceptButton = banner.querySelector('[data-hdt-cookie-accept]');
    const refuseButton = banner.querySelector('[data-hdt-cookie-refuse]');

    if (acceptButton) {
      acceptButton.addEventListener('click', () => {
        writeStorage(STORAGE_KEY, 'accepted');
        hideBanner(banner);
      });
    }

    if (refuseButton) {
      refuseButton.addEventListener('click', () => {
        writeStorage(STORAGE_KEY, 'refused');
        hideBanner(banner);
      });
    }
  }

  function hideBanner(banner) {
    banner.hidden = true;
    document.dispatchEvent(
      new CustomEvent('hdt:cookie-consent:updated', { detail: { value: readStorage(STORAGE_KEY) } })
    );
  }

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      /* storage unavailable, fail silently */
    }
  }
})();
